import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface OutOfOfficeCoveringProviderParams {
  patientId?: string;
  practitionerId?: string;
}

interface Coverage {
  id: number;
  userId: number;
  coveringUserId: number;
  start: string;
  end: string;
  coveringPractitionerDisplayName?: string;
}

interface OutOfOfficeCoveringProviderResponse {
  coverage: Coverage;
}

export const useOutOfOfficeCoveringProvider = ({
  patientId,
  practitionerId,
}: OutOfOfficeCoveringProviderParams) => {
  return useApi<OutOfOfficeCoveringProviderResponse>({
    queryOptions: {
      queryFn: async () => {
        const params = patientId
          ? { userId: patientId }
          : { practitionerId: practitionerId };

        const response = await axiosInstance.get(
          "/ehr-admin/out-of-office/covering-provider",
          { params },
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.Chat.CareTeam.OUT_OF_OFFICE_COVERING_PROVIDER(
        patientId,
        practitionerId,
      ),
      enabled: Boolean(patientId) || Boolean(practitionerId),
      refetchOnWindowFocus: false,
    },
  });
};
